import {createSlice} from "@reduxjs/toolkit";

const initialUserProfileState = {
  actionsLoading: false,
  error: ""
};
export const callTypes = {
  action: "action"
};

export const userProfileSlice = createSlice({
  name: "userProfile",
  initialState: initialUserProfileState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    userProfileChangePassword: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
    },
    userProfileUpdateInfo: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
    },
    
  }
});
